import { LAYOUTS, } from '@voltmoney/types';
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconAlignmentTokens, IconSizeTokens, IconTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTIONS } from './types';
import { authCAS, fetchMyPortfolio, goBack, navToFetch } from './actions';
import { AssetRepositoryMap, AssetRepositoryType, isDarkModeTheme, } from '../../../configs/config';
import SharedPropsService from '../../../SharedPropsService';
import { heightMap } from '../../../configs/height';
import AsyncStorage from '@react-native-async-storage/async-storage';
const isDarkMode = isDarkModeTheme();
export const template = (applicationId, assetRepository, emailId, panNumber, phoneNumber, identifier, otpChannel, noOfDigits, isRetryAllowed) => {
    return {
        layout: {
            id: ROUTE.OTP_AUTH_CAS,
            type: LAYOUTS.MODAL,
            style: {
                height: heightMap[ROUTE.OTP_AUTH_CAS]
            },
            widgets: [
                {
                    id: "headerStack",
                    type: WIDGET.STACK,
                },
                { id: "space0", type: WIDGET.SPACE },
                // { id: "title", type: WIDGET.TEXT },
                { id: "space1", type: WIDGET.SPACE },
                { id: "emailSubtitle", type: WIDGET.EMAIL_SUBTITLE },
                { id: "space2", type: WIDGET.SPACE },
                { id: 'otpModalScreen', type: WIDGET.OTP_MODAL_SCREEN },
            ],
        },
        datastore: {
            otpModalScreen: {
                id: 'tf_getPortfolioScreen_otp',
                title: "Enter OTP",
                type: InputTypeToken.OTP,
                isDarkMode: isDarkMode ? true : false,
                resendTimer: assetRepository === AssetRepositoryType.MFCENTRAL ? 15 : 60,
                state: InputStateToken.DEFAULT,
                keyboardType: KeyboardTypeToken.numberPad,
                charLimit: noOfDigits,
                action: {
                    type: ACTIONS.AUTH_CAS,
                    routeId: ROUTE.OTP_AUTH_CAS,
                    payload: {
                        value: "",
                        applicationId,
                        assetRepository,
                        emailId,
                        panNumber,
                        phoneNumber,
                        isRetryAllowed
                    },
                },
                otpAction: {
                    type: ACTIONS.RESEND_OTP_AUTH_CAS,
                    payload: {
                        value: "",
                        applicationId,
                        assetRepository,
                        emailId,
                        panNumber,
                        phoneNumber,
                        isRetryAllowed
                    },
                    routeId: ROUTE.OTP_AUTH_CAS,
                },
            },
            space0: {
                size: SizeTypeTokens.Size6,
            },
            headerStack: {
                type: StackType.row,
                alignItems: StackAlignItems.center,
                justifyContent: StackJustifyContent.spaceBetween,
                widgetItems: [
                    // { id: "icon", type: WIDGET.ICON },
                    { id: "title", type: WIDGET.TEXT },
                    { id: "leadIcon", type: WIDGET.BUTTON },
                ],
            },
            title: {
                label: `Enter ${noOfDigits}-digit OTP`,
                fontSize: FontSizeTokens.XL,
                color: isDarkMode ? ColorTokens.DARK_GREY_THEME : ColorTokens.Grey_Night,
                fontFamily: FontFamilyTokens.Poppins,
                fontWeight: "600",
            },
            emailSubtitle: {
                label: `${AssetRepositoryMap.get(assetRepository).NAME} has sent an OTP to`,
                subLabel: `${identifier}`,
                iconUrl: otpChannel === "SMS" ? "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/icon_holder_msg.png"
                    : "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/icon_holder.png",
                iconName: otpChannel === "SMS" ? IconTokens.VERIFY_SMS_ICON : IconTokens.EMAIL_VERIFY_MAIL_ICON,
                isDarkMode: isDarkMode ? true : false
            },
            leadIcon: {
                id: 'bt_getPortfolioScreen_cancel',
                label: "",
                type: ButtonTypeTokens.SmallGhost,
                width: ButtonWidthTypeToken.CONTENT,
                labelColor: ColorTokens.Grey_Night,
                icon: {
                    name: IconTokens.Cross,
                    align: IconAlignmentTokens.right,
                    size: IconSizeTokens.XXL,
                },
                action: {
                    type: ACTIONS.GO_BACK,
                    payload: {
                        value: "",
                        widgetId: "input",
                        isResend: false,
                    },
                    routeId: ROUTE.OTP_AUTH_CAS,
                },
            },
            icon: {
                name: otpChannel === "SMS"
                    ? IconTokens.SMS
                    : IconTokens.OTPEmail,
                size: IconSizeTokens.Size52,
            },
            subTitleStack: {
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                justifyContent: StackJustifyContent.flexStart,
                widgetItems: [
                    { id: "subTitle", type: WIDGET.TEXT },
                    { id: "subTitle2", type: WIDGET.TEXT },
                ],
            },
            subTitle: {
                label: `OTP sent to `,
                color: ColorTokens.Grey_Charcoal,
                fontFamily: FontFamilyTokens.Inter,
                fontSize: FontSizeTokens.SM,
                fontWeight: "500",
            },
            subTitle2: {
                label: `${identifier}`,
                color: ColorTokens.Grey_Charcoal,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: "600",
                fontSize: FontSizeTokens.SM,
            },
            input: {
                id: 'tf_getPortfolioScreen_otp',
                title: "Enter OTP",
                type: InputTypeToken.OTP,
                isDarkMode: isDarkMode ? true : false,
                resendTimer: 60,
                state: InputStateToken.DEFAULT,
                keyboardType: KeyboardTypeToken.numberPad,
                charLimit: AssetRepositoryMap.get(assetRepository).OTP_LENGTH,
                action: {
                    type: ACTIONS.AUTH_CAS,
                    routeId: ROUTE.OTP_AUTH_CAS,
                    payload: {
                        value: "",
                        applicationId,
                        assetRepository,
                        isRetryAllowed
                    },
                },
                otpAction: {
                    type: ACTIONS.RESEND_OTP_AUTH_CAS,
                    payload: {
                        value: "",
                        applicationId,
                        assetRepository,
                        isRetryAllowed,
                    },
                    routeId: ROUTE.OTP_AUTH_CAS,
                },
            },
            space1: { size: SizeTypeTokens.MD },
            space2: { size: SizeTypeTokens.XXXL },
        },
    };
};
export const otpVerifyAuthCASMF = {
    onLoad: async (_, { assetRepository, identifier, otpChannel, noOfDigits, isRetryAllowed }) => {
        _.instrumentTrack("FETCH_OTP_MODAL_VIEWED", {
            RTA: assetRepository
        });
        await SharedPropsService.setAssetRepositoryType(assetRepository);
        const user = await SharedPropsService.getUser();
        let applicationId = '';
        if (await AsyncStorage.getItem("application_id") !== null) {
            applicationId = await AsyncStorage.getItem("application_id");
        }
        else {
            applicationId = user.linkedApplications[0].applicationId;
        }
        const formattedIdentifier = identifier.replace(/(\+91)(\d+)/, '$1 $2');
        const emailId = user.linkedBorrowerAccounts[0].accountHolderEmail;
        const panNumber = user.linkedBorrowerAccounts[0].accountHolderPAN;
        const phoneNumber = user.linkedBorrowerAccounts[0].accountHolderPhoneNumber;
        return Promise.resolve(template(applicationId, AssetRepositoryType[assetRepository], emailId, panNumber, phoneNumber, formattedIdentifier, otpChannel, noOfDigits, isRetryAllowed));
    },
    actions: {
        [ACTIONS.AUTH_CAS]: authCAS,
        [ACTIONS.RESEND_OTP_AUTH_CAS]: fetchMyPortfolio,
        [ACTIONS.GO_BACK]: goBack,
        [ACTIONS.NAV_TO_FETCH]: navToFetch,
    },
    clearPrevious: false,
};
